import React from "react";
import { Link, useHistory } from "react-router-dom";
import { UserContext } from "../../context/user";
import { ExtraContext } from "../../context/ExtraFunctions";
import { CartServerSide } from "../../context/api_response";
import { CartContext } from "../../context/cart";
import ServerSide from "../../strapi/handle_cart_functions/server_side";
import { ReactComponent as Bag } from "../../assets/components-icons/bag.svg";
import { motion, AnimatePresence } from "framer-motion";
import { DishesCardWrapper } from "../Layout/DishesCardWrapper";
import { Button } from "../Layout/Elements";

const DishCard = ({
  image,
  Title,
  Description,
  price_small,
  price_medium,
  price_large,
  picksize,
  id,
  category,
  toppings,
  ingredients,
}) => {
  const { user } = React.useContext(UserContext);
  const {
    get_size,
    handleAlert,
    setGif,
    edit,
    pagination,
    handlePagination,
  } = React.useContext(ExtraContext);
  let dish = {
    image,
    Title,
    price_small,
    price_large,
    price_medium,
    id,
    toppings,
    ingredients,
  };
  const { userInfo } = React.useContext(CartServerSide);
  const { add_to_cart } = React.useContext(CartContext);
  let history = useHistory();

  return (
    <DishesCardWrapper>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          key={id}
          transition={{ duration: 0.7 }}
          exit={{ opacity: 0, x: 100 }}
          className="d-lg-flex div-control"
        >
          <img src={image[0].url} className="big-img medium-img" alt={Title} />
          <div className="div-control-colors details">
            <div className="d-flex flex-column align-items-start">
              <h5>
                <Link to={`/pizza-product/${Title}/${category}/${id}`}>
                  {Title}
                </Link>
              </h5>
              <p>{Description}</p>
            </div>
            <div className="d-flex align-items-center">
              <div>
                <span>Pick size</span>
              </div>
              <div className="border-line ml-1"></div>
            </div>

            <div className="d-flex justify-content-between mt-4">
              {picksize.map((list) => {
                return (
                  <div key={list.id}>
                    <label className="container-radio ml-1">
                      <input
                        value={list.value}
                        name={list.name}
                        onClick={get_size}
                        type="radio"
                      />
                      <span className="checkmark"></span>
                      <span className="pick-size">{list.text}</span>
                      <small className="pick-price ml-1">
                        €{list.text === "SM" && price_small}
                        {list.text === "MD" && price_medium}
                        {list.text === "LG" && price_large}
                      </small>
                    </label>
                  </div>
                );
              })}
            </div>

            <div className="d-flex  mt-4">
              <Button
                width="100%"
                radius="40px"
                padding="10px"
                onClick={(e) => {
                  ServerSide(
                    e,
                    user,
                    userInfo,
                    dish,
                    handleAlert,
                    history,
                    setGif,
                    edit,
                    add_to_cart
                  );
                  handlePagination(id);
                }}
                key={id}
                className={` btn-standard ${
                  pagination === id && `  btn-highlight`
                }`}
              >
                <Bag
                  onClick={() => handlePagination(id)}
                  className={` svgAll svg-standard  ${
                    pagination === id && `svgAll svgHighlight`
                  }`}
                />
                <span
                  onClick={() => handlePagination(id)}
                  className={`text-standard ml-3 ${
                    pagination === id && `text-highlight`
                  }`}
                >
                  Add to cart
                </span>
              </Button>
            </div>
          </div>
        </motion.div>
        <div className="mt-5  borderAll borderGrey"></div>
      </AnimatePresence>
    </DishesCardWrapper>
  );
};

export { DishCard as default };
